/* global axios */

import ApiClient from './ApiClient';

class ActivityLogsAPI extends ApiClient {
  constructor() {
    super('activity_logs', { accountScoped: true });
  }

  get({ page = 1, createdAtGte, createdAtLte, agentId, q } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        created_at_gte: createdAtGte,
        created_at_lte: createdAtLte,
        agent_id: agentId,
        q,
      },
    });
  }
}

export default new ActivityLogsAPI();
